import Config from "../config";
import axios from "axios";
import {notification} from "../helpers";


export function post(file){
    return (dispatch) => {

        var fr = new FileReader();

        dispatch({
            type: 'IMPORT_UPLOAD_INPROGRESS',
            payload: true
        });


        fr.onload = function(event) {

            const formData = new FormData();
            formData.append("file", file);

            var defaultHeaders = Config.api.getConfig();
            defaultHeaders = {
                ...defaultHeaders,
                "X-Requested-With": "XMLHttpRequest"
            };

            return axios.post(Config.api.getDomain() + 'dackis/files',  formData , defaultHeaders ).then(response => {

                dispatch({
                    type: 'IMPORT_UPLOAD_SUCCESS',
                    payload: response
                });
                if (response.data.success && response.data.message){
                    notification(response.data.message);
                } else {
                    notification('Något gick fel! Testa dokumentformat!');
                }

            }).catch(error => {

                dispatch({
                    type: 'IMPORT_UPLOAD_FAILURE',
                    payload: error
                });
                notification('Filuppladdning misslyckades!');
            })

        };

        fr.readAsText(file);

    }
}



// WEBPACK FOOTER //
// ./src/actions/fileImport.js